(function () {
  'use strict';

  /* ---------- light / dark toggle ---------- */
  (function () {
    var root = document.documentElement;
    var toggle = document.getElementById('themeToggle');
    var label = document.getElementById('themeLabel');
    var icon = document.getElementById('themeIcon');
    if (!toggle || !label || !icon) return;

    var MOON = '<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/>';
    var SUN = '<circle cx="12" cy="12" r="4.2"/><path d="M12 3v2.2M12 18.8V21M4.2 12H2M22 12h-2.2M5.6 5.6l1.6 1.6M16.8 16.8l1.6 1.6M18.4 5.6l-1.6 1.6M7.2 16.8l-1.6 1.6"/>';

    function paint(mode) {
      icon.innerHTML = mode === 'light' ? SUN : MOON;
      label.textContent = mode === 'light' ? 'Light' : 'Dark';
      toggle.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    }
    paint(root.getAttribute('data-mode') || 'dark');

    toggle.addEventListener('click', function () {
      var next = root.getAttribute('data-mode') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-mode', next);
      paint(next);
      try { localStorage.setItem('xb-mode', next); } catch (e) {}
    });
  })();

  /* ---------- hero "network" dropdown ---------- */
  (function () {
    var wrap = document.getElementById('networkSelectWrap');
    var btn = document.getElementById('networkSelectBtn');
    var menu = document.getElementById('networkMenu');
    if (!wrap || !btn || !menu) return;

    function closeMenu() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
    function openMenu() {
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
    function go(dest) {
      closeMenu();
      if (!dest) return;
      if (dest.charAt(0) === '#') {
        var target = document.querySelector(dest);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.href = dest;
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) openMenu(); else closeMenu();
    });

    Array.prototype.forEach.call(menu.querySelectorAll('.network-menu-item:not(.is-disabled)'), function (item) {
      item.addEventListener('click', function () { go(this.getAttribute('data-href')); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(this.getAttribute('data-href')); }
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  })();

  /* ---------- intro animation cleanup ----------
     A running CSS animation forces its element into its own stacking context, which can trap a
     later z-index (like the network dropdown) below unrelated page content. Detach the intro
     animation once it has played. */
  (function () {
    var risers = document.querySelectorAll('.rise');
    risers.forEach(function (el) {
      el.addEventListener('animationend', function () {
        el.style.animation = 'none';
      }, { once: true });
    });
    window.setTimeout(function () {
      risers.forEach(function (el) { el.style.animation = 'none'; });
    }, 1200);
  })();

  /* ---------- network search: send the search to the right storefront ---------- */
  (function () {
    var form = document.getElementById('xb-search-form');
    var input = document.getElementById('xb-search');
    var note = document.getElementById('xb-search-note');
    var dataEl = document.getElementById('xb-brands');
    if (!form || !input || !dataEl) return;

    var brands = [];
    try { brands = JSON.parse(dataEl.textContent) || []; } catch (e) { brands = []; }
    var salesEmail = dataEl.getAttribute('data-sales-email') || 'sales@xpertbuy.com';

    brands.forEach(function (b) {
      var words = (b.keywords || '').split(/[,\n]/).map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
      var nm = (b.name || '').trim().toLowerCase();
      if (nm && words.indexOf(nm) === -1) words.push(nm);
      b._words = words;
    });

    function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    // Best match = brand whose longest matching keyword is longest. Keywords match at the start of a word.
    function findBrand(query) {
      var q = query.toLowerCase();
      var best = null, bestLen = 0;
      brands.forEach(function (b) {
        b._words.forEach(function (w) {
          if (w.length > bestLen && new RegExp('(^|[^a-z0-9])' + escapeRe(w)).test(q)) {
            best = b; bestLen = w.length;
          }
        });
      });
      return best;
    }

    function firstLive() {
      for (var i = 0; i < brands.length; i++) if (brands[i].status === 'live' && brands[i].url) return brands[i];
      return null;
    }

    function destination(brand, q) {
      var enc = encodeURIComponent(q);
      if (brand.searchUrl) return brand.searchUrl.replace(/\{q\}/g, enc);
      var base = (brand.url || '').replace(/\/+$/, '');
      return base + '/search?type=product&q=' + enc;
    }

    function hideNote() { if (note) { note.hidden = true; note.innerHTML = ''; } }

    function showSoon(brand, q) {
      if (!note) return;
      var subject = 'Quote request: ' + brand.name + ' — ' + q;
      var live = firstLive();
      note.innerHTML = '';
      var close = document.createElement('button');
      close.type = 'button'; close.className = 'close'; close.setAttribute('aria-label', 'Dismiss'); close.textContent = '×';
      close.addEventListener('click', hideNote);
      note.appendChild(close);

      var p = document.createElement('div');
      var strong = document.createElement('strong');
      strong.textContent = brand.name;
      p.appendChild(strong);
      p.appendChild(document.createTextNode(' is joining the network soon. Our team can quote it today — '));
      var a = document.createElement('a');
      a.href = 'mailto:' + salesEmail + '?subject=' + encodeURIComponent(subject);
      a.textContent = 'email sales';
      p.appendChild(a);
      p.appendChild(document.createTextNode('.'));
      if (live) {
        p.appendChild(document.createTextNode(' Looking for something else? '));
        var b = document.createElement('a');
        b.href = destination(live, q);
        b.textContent = 'Search the ' + live.name + ' store';
        p.appendChild(b);
        p.appendChild(document.createTextNode('.'));
      }
      note.appendChild(p);
      note.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      var brand = findBrand(q) || firstLive();
      if (!brand) return; // nothing configured: let the form submit normally
      e.preventDefault();
      if (brand.status === 'live' && (brand.searchUrl || brand.url)) {
        window.location.href = destination(brand, q);
      } else {
        showSoon(brand, q);
      }
    });

    input.addEventListener('input', hideNote);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideNote(); });
  })();
})();
